const NAME = "PERFORMANCE_INTERVIEW_FEEDBACK_AND_RESULTS";

export default NAME;
